export const REFERENCE_FPS = 60;
export const MAX_DELTA_TIME = 1.0;
